module.exports = __webpack_public_path__ + "static/media/white_tick.720fa168.svg";